var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebhookActionType } from './WebhookActionType';
import { TradingWebhookRequestMessage } from '@shared/utils/DirectMessages/Webhooks/TradingWebhookRequestMessage';
import { TradingWebhookListRequestMessage } from '@shared/utils/DirectMessages/Webhooks/TradingWebhookListRequestMessage';
export class WebhooksManager {
    constructor(iConnection) {
        this.iConnection = iConnection;
    }
    getWebhooksAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const message = new TradingWebhookListRequestMessage();
            const response = yield this.iConnection.sendOutputMessageAsync(message);
            if (response === null) {
                return [];
            }
            return response.webhooks.map((webhook) => ({
                id: webhook.id,
                name: webhook.name,
                creationDate: webhook.createdAt,
                expirationDate: webhook.expireAt
            }));
        });
    }
    createWebhookAsync(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = new TradingWebhookRequestMessage();
            message.actionType = WebhookActionType.GENERATE;
            message.name = name;
            const response = yield this.iConnection.sendOutputMessageAsync(message);
            if (response === null) {
                return null;
            }
            return {
                id: response.id,
                name: response.name,
                creationDate: response.createdAt,
                expirationDate: response.expireAt,
                apiKey: response.apiKey,
                secretKey: response.secretKey
            };
        });
    }
    removeWebhookAsync(webhook) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = new TradingWebhookRequestMessage();
            message.actionType = WebhookActionType.REMOVE;
            message.id = webhook.id;
            const response = yield this.iConnection.sendOutputMessageAsync(message);
            return response !== null;
        });
    }
}
